import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { parseFilterArgs, parseQueryArgs, functionalUpdate, noop, hashQueryKey, partialMatchKey, hashQueryKeyByOptions } from './utils.mjs';
import { QueryCache } from './queryCache.mjs';
import { MutationCache } from './mutationCache.mjs';
import { focusManager } from './focusManager.mjs';
import { onlineManager } from './onlineManager.mjs';
import { notifyManager } from './notifyManager.mjs';
import { infiniteQueryBehavior } from './infiniteQueryBehavior.mjs';
import { defaultLogger } from './logger.mjs';

// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QueryClient);
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || defaultLogger;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
    this.mountCount = 0;
    if (process.env.NODE_ENV !== 'production' && config.logger) {
      this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
    }
  }
  _createClass(QueryClient, [{
    key: "mount",
    value: function mount() {
      var _this = this;
      this.mountCount++;
      if (this.mountCount !== 1) return;
      this.unsubscribeFocus = focusManager.subscribe(function () {
        if (focusManager.isFocused()) {
          _this.resumePausedMutations();
          _this.queryCache.onFocus();
        }
      });
      this.unsubscribeOnline = onlineManager.subscribe(function () {
        if (onlineManager.isOnline()) {
          _this.resumePausedMutations();
          _this.queryCache.onOnline();
        }
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this$unsubscribeFocu, _this$unsubscribeOnli;
      this.mountCount--;
      if (this.mountCount !== 0) return;
      (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
      this.unsubscribeFocus = undefined;
      (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
      this.unsubscribeOnline = undefined;
    }
  }, {
    key: "isFetching",
    value: function isFetching(arg1, arg2) {
      var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        _parseFilterArgs2 = _slicedToArray(_parseFilterArgs, 1),
        filters = _parseFilterArgs2[0];
      filters.fetchStatus = 'fetching';
      return this.queryCache.findAll(filters).length;
    }
  }, {
    key: "isMutating",
    value: function isMutating(filters) {
      return this.mutationCache.findAll(_objectSpread(_objectSpread({}, filters), {}, {
        fetching: true
      })).length;
    }
  }, {
    key: "getQueryData",
    value: function getQueryData(queryKey, filters) {
      var _this$queryCache$find;
      return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
  }, {
    key: "ensureQueryData",
    value: function ensureQueryData(arg1, arg2, arg3) {
      var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
      var cachedData = this.getQueryData(parsedOptions.queryKey);
      return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
  }, {
    key: "getQueriesData",
    value: function getQueriesData(queryKeyOrFilters) {
      return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey,
          state = _ref2.state;
        var data = state.data;
        return [queryKey, data];
      });
    }
  }, {
    key: "setQueryData",
    value: function setQueryData(queryKey, updater, options) {
      var query = this.queryCache.find(queryKey);
      var prevData = query == null ? void 0 : query.state.data;
      var data = functionalUpdate(updater, prevData);
      if (typeof data === 'undefined') {
        return undefined;
      }
      var parsedOptions = parseQueryArgs(queryKey);
      var defaultedOptions = this.defaultQueryOptions(parsedOptions);
      return this.queryCache.build(this, defaultedOptions).setData(data, _objectSpread(_objectSpread({}, options), {}, {
        manual: true
      }));
    }
  }, {
    key: "setQueriesData",
    value: function setQueriesData(queryKeyOrFilters, updater, options) {
      var _this2 = this;
      return notifyManager.batch(function () {
        return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref3) {
          var queryKey = _ref3.queryKey;
          return [queryKey, _this2.setQueryData(queryKey, updater, options)];
        });
      });
    }
  }, {
    key: "getQueryState",
    value: function getQueryState(queryKey, filters) {
      var _this$queryCache$find2;
      return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
  }, {
    key: "removeQueries",
    value: function removeQueries(arg1, arg2) {
      var _parseFilterArgs3 = parseFilterArgs(arg1, arg2),
        _parseFilterArgs4 = _slicedToArray(_parseFilterArgs3, 1),
        filters = _parseFilterArgs4[0];
      var queryCache = this.queryCache;
      notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          queryCache.remove(query);
        });
      });
    }
  }, {
    key: "resetQueries",
    value: function resetQueries(arg1, arg2, arg3) {
      var _this3 = this;
      var _parseFilterArgs5 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs6 = _slicedToArray(_parseFilterArgs5, 2),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];
      var queryCache = this.queryCache;
      var refetchFilters = _objectSpread({
        type: 'active'
      }, filters);
      return notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          query.reset();
        });
        return _this3.refetchQueries(refetchFilters, options);
      });
    }
  }, {
    key: "cancelQueries",
    value: function cancelQueries(arg1, arg2, arg3) {
      var _this4 = this;
      var _parseFilterArgs7 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs8 = _slicedToArray(_parseFilterArgs7, 2),
        filters = _parseFilterArgs8[0],
        _parseFilterArgs8$ = _parseFilterArgs8[1],
        cancelOptions = _parseFilterArgs8$ === void 0 ? {} : _parseFilterArgs8$;
      if (typeof cancelOptions.revert === 'undefined') {
        cancelOptions.revert = true;
      }
      var promises = notifyManager.batch(function () {
        return _this4.queryCache.findAll(filters).map(function (query) {
          return query.cancel(cancelOptions);
        });
      });
      return Promise.all(promises).then(noop).catch(noop);
    }
  }, {
    key: "invalidateQueries",
    value: function invalidateQueries(arg1, arg2, arg3) {
      var _this5 = this;
      var _parseFilterArgs9 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs10 = _slicedToArray(_parseFilterArgs9, 2),
        filters = _parseFilterArgs10[0],
        options = _parseFilterArgs10[1];
      return notifyManager.batch(function () {
        var _ref, _filters$refetchType;
        _this5.queryCache.findAll(filters).forEach(function (query) {
          query.invalidate();
        });
        if (filters.refetchType === 'none') {
          return Promise.resolve();
        }
        var refetchFilters = _objectSpread(_objectSpread({}, filters), {}, {
          type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
        });
        return _this5.refetchQueries(refetchFilters, options);
      });
    }
  }, {
    key: "refetchQueries",
    value: function refetchQueries(arg1, arg2, arg3) {
      var _this6 = this;
      var _parseFilterArgs11 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs12 = _slicedToArray(_parseFilterArgs11, 2),
        filters = _parseFilterArgs12[0],
        options = _parseFilterArgs12[1];
      var promises = notifyManager.batch(function () {
        return _this6.queryCache.findAll(filters).filter(function (query) {
          return !query.isDisabled();
        }).map(function (query) {
          var _options$cancelRefetc;
          return query.fetch(undefined, _objectSpread(_objectSpread({}, options), {}, {
            cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
            meta: {
              refetchPage: filters.refetchPage
            }
          }));
        });
      });
      var promise = Promise.all(promises).then(noop);
      if (!(options != null && options.throwOnError)) {
        promise = promise.catch(noop);
      }
      return promise;
    }
  }, {
    key: "fetchQuery",
    value: function fetchQuery(arg1, arg2, arg3) {
      var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
      var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

      if (typeof defaultedOptions.retry === 'undefined') {
        defaultedOptions.retry = false;
      }
      var query = this.queryCache.build(this, defaultedOptions);
      return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
  }, {
    key: "prefetchQuery",
    value: function prefetchQuery(arg1, arg2, arg3) {
      return this.fetchQuery(arg1, arg2, arg3).then(noop).catch(noop);
    }
  }, {
    key: "fetchInfiniteQuery",
    value: function fetchInfiniteQuery(arg1, arg2, arg3) {
      var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
      parsedOptions.behavior = infiniteQueryBehavior();
      return this.fetchQuery(parsedOptions);
    }
  }, {
    key: "prefetchInfiniteQuery",
    value: function prefetchInfiniteQuery(arg1, arg2, arg3) {
      return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop).catch(noop);
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      return this.mutationCache.resumePausedMutations();
    }
  }, {
    key: "getQueryCache",
    value: function getQueryCache() {
      return this.queryCache;
    }
  }, {
    key: "getMutationCache",
    value: function getMutationCache() {
      return this.mutationCache;
    }
  }, {
    key: "getLogger",
    value: function getLogger() {
      return this.logger;
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return this.defaultOptions;
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      this.defaultOptions = options;
    }
  }, {
    key: "setQueryDefaults",
    value: function setQueryDefaults(queryKey, options) {
      var result = this.queryDefaults.find(function (x) {
        return hashQueryKey(queryKey) === hashQueryKey(x.queryKey);
      });
      if (result) {
        result.defaultOptions = options;
      } else {
        this.queryDefaults.push({
          queryKey: queryKey,
          defaultOptions: options
        });
      }
    }
  }, {
    key: "getQueryDefaults",
    value: function getQueryDefaults(queryKey) {
      if (!queryKey) {
        return undefined;
      } // Get the first matching defaults

      var firstMatchingDefaults = this.queryDefaults.find(function (x) {
        return partialMatchKey(queryKey, x.queryKey);
      }); // Additional checks and error in dev mode

      if (process.env.NODE_ENV !== 'production') {
        // Retrieve all matching defaults for the given key
        var matchingDefaults = this.queryDefaults.filter(function (x) {
          return partialMatchKey(queryKey, x.queryKey);
        }); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key

        if (matchingDefaults.length > 1) {
          this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(queryKey) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults.");
        }
      }
      return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
  }, {
    key: "setMutationDefaults",
    value: function setMutationDefaults(mutationKey, options) {
      var result = this.mutationDefaults.find(function (x) {
        return hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey);
      });
      if (result) {
        result.defaultOptions = options;
      } else {
        this.mutationDefaults.push({
          mutationKey: mutationKey,
          defaultOptions: options
        });
      }
    }
  }, {
    key: "getMutationDefaults",
    value: function getMutationDefaults(mutationKey) {
      if (!mutationKey) {
        return undefined;
      } // Get the first matching defaults

      var firstMatchingDefaults = this.mutationDefaults.find(function (x) {
        return partialMatchKey(mutationKey, x.mutationKey);
      }); // Additional checks and error in dev mode

      if (process.env.NODE_ENV !== 'production') {
        // Retrieve all matching defaults for the given key
        var matchingDefaults = this.mutationDefaults.filter(function (x) {
          return partialMatchKey(mutationKey, x.mutationKey);
        }); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key

        if (matchingDefaults.length > 1) {
          this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(mutationKey) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults.");
        }
      }
      return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
  }, {
    key: "defaultQueryOptions",
    value: function defaultQueryOptions(options) {
      if (options != null && options._defaulted) {
        return options;
      }
      var defaultedOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions.queries), this.getQueryDefaults(options == null ? void 0 : options.queryKey)), options), {}, {
        _defaulted: true
      });
      if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
        defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
      } // dependent default values

      if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
        defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
      }
      if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
        defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
      }
      return defaultedOptions;
    }
  }, {
    key: "defaultMutationOptions",
    value: function defaultMutationOptions(options) {
      if (options != null && options._defaulted) {
        return options;
      }
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions.mutations), this.getMutationDefaults(options == null ? void 0 : options.mutationKey)), options), {}, {
        _defaulted: true
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.queryCache.clear();
      this.mutationCache.clear();
    }
  }]);
  return QueryClient;
}();
export { QueryClient };